import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App'
setTimeout(function(){
    ReactDOM.render(<App/>,document.getElementById('app'));
},300);


// WEBPACK FOOTER //
// ./main.js